import { API_ENDPOINTS } from '@/src/constants';
import { fireblocksClient } from '@/src/helpers';
import { ExecuteXrplTransactionRequest } from '@/src/models';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FireblocksQueryKeys } from './fireblocks.types';

export const useExecuteFireblocksTransaction = (
  opts?: UseMutationOptions<any, Error, ExecuteXrplTransactionRequest>,
  additionalMutationkeys?: string[]
) => {
  return useMutation({
    mutationFn: (data: ExecuteXrplTransactionRequest) =>
      fireblocksClient.post(API_ENDPOINTS.XRPL, data).then((res) => res.data),

    mutationKey: [FireblocksQueryKeys.ExecuteTransaction, ...(additionalMutationkeys || [])],
    ...opts,
  });
};
